import {IData} from "~/stories_widget/models/AbstractModel";
import {MutationPayload} from "vuex";
import RootState from "~/stories_widget/store/rootState";
import {STORY_LIST_TYPE} from "~/stories_widget/store/vuex-stories-module";

export type Url = Brand<string, "url">;

export type ClickOnStoryInternalPayload = {
    id: number;
    listType: STORY_LIST_TYPE;
    windowReferer: STORY_READER_WINDOW_REFERER
};

export type ClickOnButtonPayload = {
    id: number;
    index: number;
    url: Url;
};

export type ClickOnStoryPayload = ClickOnButtonPayload & {
    isDeeplink: boolean;
};

export type ClickOnFavoriteCellInternalPayload = {
    id: number;
    items: Array<IData>;
};

export type SyncStoreEvent = {
    mutation: MutationPayload;
};

export enum STORY_READER_WINDOW_REFERER {
    default,
    favorite
};

